import { render, staticRenderFns } from "./CollegeInfoView.vue?vue&type=template&id=68138d3c&scoped=true"
import script from "./CollegeInfoView.vue?vue&type=script&lang=js"
export * from "./CollegeInfoView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68138d3c",
  null
  
)

export default component.exports